export const SIDE_NAVIGATION = "side-navigation";
export const TOP_NAVIGATION = "top-navigation";
export const TWO_COLUMN_NAVIGATION = "two-column-navigation";
export const MIXED_NAVIGATION = "mixed-navigation";
